import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import moment from "moment";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-calendar-date-display",
  templateUrl: "./calendar-date-display.component.html",
  styleUrls: ["./calendar-date-display.component.scss"],
  imports: [NgClass]
})
export class CalendarDateDisplayComponent implements OnChanges {
  @Input()
  public displayDate: Date;
  @Input()
  public mini: boolean = false;
  dateComponent: string;
  monthComponent: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.displayDate) {
      this.dateComponent = "";
      this.monthComponent = "TBC";
      return;
    }
    this.dateComponent = moment(this.displayDate).date().toString(10);
    if (moment().year() === moment(this.displayDate).year()) {
      this.monthComponent = moment(this.displayDate)
        .format("MMM 'YY")
        .toUpperCase();
    } else {
      this.monthComponent = moment(this.displayDate)
        .format("MMM 'YY")
        .toUpperCase();
    }
  }
}
